import React from "react";
import {useTranslation} from "react-i18next";
import {CustomTypography} from "../landing-page/hero-section/HeroSection.style";
import {CustomStackFullWidth} from "../../styled-components/CustomStyles.style";
import {NoSsr} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const CustomPhoneInput = ({
                              value,
                              onHandleChange,
                              initCountry,
                              touched,
                              errors,
                              lanDirection,
                              height,
                              borderRadius,
                          }) => {
    const changeHandler = (phoneNumber, country) => {
        // Remove the + prefix if it exists and add it back
        const cleanNumber = phoneNumber.replace(/^\+/, '');
        onHandleChange(cleanNumber);
    };

    const {t} = useTranslation();
    const defaultCountry = initCountry?.toLowerCase();
    
    return (
        <NoSsr>
            <CustomStackFullWidth alignItems="flex-start" spacing={0.8}>
                {lanDirection && (
                    <PhoneInput
                        country={defaultCountry}
                        value={value?.replace(/^\+/, '') || ''}
                        onChange={changeHandler}
                        placeholder={t("Enter phone number")}
                        enableSearch={true}
                        searchPlaceholder={t("Search country")}
                        searchNotFound={t("No country found")}
                        preferredCountries={['us', 'gb', 'ca', 'au']}
                        containerStyle={{
                            width: "100%",
                        }}
                        inputStyle={{
                            width: "100%",
                            height: height || "56px",
                            fontSize: "14px",
                            padding: "16px 14px 16px 50px",
                            border: "1px solid #e0e0e0",
                            borderRadius: borderRadius || "5px",
                        }}
                        buttonStyle={{
                            border: "1px solid #e0e0e0",
                            borderRadius: borderRadius ? `${borderRadius} 0px 0px ${borderRadius}` : "5px 0px 0px 5px",
                            borderRight: "none",
                        }}
                        dropdownStyle={{
                            borderRadius: "5px",
                        }}
                    />
                )}
                {touched && errors && (
                    <CustomTypography
                        variant="caption"
                        sx={{
                            ml: "10px",
                            fontWeight: "inherit",
                            color: (theme) => theme.palette.error.main,
                        }}
                    >
                        {errors}
                    </CustomTypography>
                )}
            </CustomStackFullWidth>
        </NoSsr>
    );
};

export default CustomPhoneInput;
